// src/components/course/CourseRunningStatus.js
import React from "react";

function CourseRunningStatus({
  type,
  distance,
  time,
  speed,
  heartRate,
  calorie,
  onEndCourse,
  buttonText = "코스 종료", // [추가] 버튼 텍스트를 props로 받음 (기본값: 코스 종료)
}) {
  const displayCalorie = calorie || 0;
  const displayHeartRate = heartRate || 0;

  const InfoItem = ({ label, value, unit, colorClass = "text-gray-900" }) => (
    <div className="flex flex-col items-center justify-center p-3 bg-gray-50 rounded-2xl">
      <span className="text-xs font-bold text-gray-400 mb-1">{label}</span>
      <div className={`text-xl font-bold ${colorClass}`}>
        {value}{" "}
        <span className="text-xs font-medium text-gray-500">{unit}</span>
      </div>
    </div>
  );

  return (
    <div className="bg-white rounded-[24px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 space-y-6">
      {/* 1. 메인 타이머 & 거리 */}
      <div className="text-center space-y-2">
        <div className="inline-block px-3 py-1 bg-blue-50 text-blue-500 text-xs font-bold rounded-full mb-2">
          {type === "러닝" ? "🏃 러닝 중" : "🚶 산책 중"}
        </div>
        <div className="text-5xl font-bold text-gray-800 tracking-tight">
          {time}
        </div>
        <div className="text-lg font-bold text-gray-500">
          {distance} <span className="text-sm">km</span>
        </div>
      </div>

      {/* 2. 상세 정보 그리드 */}
      <div className="grid grid-cols-3 gap-3">
        <InfoItem label="속도" value={speed} unit="km/h" />
        <InfoItem
          label="심박수"
          value={displayHeartRate}
          unit="bpm"
          colorClass="text-red-500"
        />
        <InfoItem
          label="칼로리"
          value={displayCalorie}
          unit="kcal"
          colorClass="text-orange-500"
        />
      </div>

      {/* 3. 버튼 (텍스트 동적 변경) */}
      <button
        type="button"
        onClick={onEndCourse}
        className="w-full h-14 rounded-2xl bg-gray-900 text-white text-base font-bold shadow-lg hover:bg-gray-800 transition-all active:scale-[0.98]"
      >
        {buttonText}
      </button>
    </div>
  );
}

export default CourseRunningStatus;
